import React from "react";
import { Card } from "react-bootstrap";
import { trimInvalidDate, trimInvalidUTCDate } from './../../../helpers/api/utils';


const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  try {
    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr; // fallback to raw string
    return d.toLocaleDateString("en-US");
  } catch {
    return dateStr;
  }
};

const getEventDescription = (ev) => {
  switch (ev.eventType) {
    case "New":
      return (
        <>
          New License <strong>{ev.licenseNumber}</strong> has been registered for{" "}
          <strong>{ev.companyName}</strong>{" "}in our system
          {/* <strong>{formatDate(ev.createdDate)}</strong> */}
        </>
      );

    case "Renewal":
      return (
        <>
          License <strong>{ev.licenseNumber}</strong> for{" "}
          <strong>{ev.companyName}</strong> has been renewed {" "}
          {/* <strong>{formatDate(ev.createdDate)}</strong> */}
        </>
      );

    case "Expiry":
      return (
        <>
          License <strong>{ev.licenseNumber}</strong> for{" "}
          <strong>{ev.companyName}</strong> has expired{" "}
        </>
      );

    default:
      return "Unknown event";
  }
};

const FollowedEvents = ({ events = [] }) => {
  if (!events || events.length === 0) {
    return (
      <div className="placeholder-box">
        No followed events found.
      </div>
    );
  }

  return (
    <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
      <ul className="list-unstyled mb-0">
        {[...events]
        .sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate)).map((ev, index) => (
          <li
            key={index}
            className="d-flex align-items-start mb-3"
          >
            {/* PERFECT ROUND BULLET */}
            <span
              style={{
                width: "10px",
                height: "10px",
                minWidth: "10px",
                minHeight: "10px",
                borderRadius: "50%",
                marginTop: "6px",
                marginRight: "12px",
                flexShrink: 0,
                backgroundColor:"#0d6efd"
                  // ev.eventType === "Expiry"
                  //   ? "#dc3545"   // red
                  //   : ev.eventType === "Renewal"
                  //   ? "#0d6efd"   // blue
                  //   : "#198754"   // green
              }}
            />

            {/* CONTENT */}
            {/* <div>
              <div>{getEventDescription(ev)}</div>
              <div className="text-muted small">
                {formatDate(ev.createdDate
                  // ev.eventType === "Expiry"
                  //   ? ev.createdDate
                  //   : ev.createdDate
                )}
              </div>
            </div> */}
            <div style={{ fontSize: "12px" }}>
            <div>{getEventDescription(ev)}</div>
            <div className="text-muted">
            {trimInvalidUTCDate(
                 ev.eventType === "Expiry"
                   ? ev.licenseExpiryDate
                   : ev.createdDate
              )}
            </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FollowedEvents;

// export default FollowedEvents;
